// import React from "react";

// function RadiusCircles({ pinCoord, distances = [500, 1000, 1500], zoom = 1, isVisible, pos, onHideRadius, bigCircleRef }) {
//   if (!isVisible || !pos) return null;

//   const offset = -200;
//   const centerX = pinCoord[0] * zoom + pos.x;
//   const centerY = (pinCoord[1] + offset) * zoom + pos.y;

//   return (
//     <div
//       style={{
//         position: "absolute",
//         left: 0,
//         top: 0,
//         width: "100%",
//         height: "100%",
//         opacity: isVisible ? 1 : 0,
//         transition: "opacity 0.3s ease",
//         pointerEvents: "none", // ← تغيير مهم: الـ wrapper مش بيستقبل كليكات
//         zIndex: 8,
//       }}
//     >
//       {/* الخلفية السوداء الشفافة - بس الكليك عليها يخفي الـ radius */}
//       <div
//         onClick={onHideRadius}
//         style={{
//           position: "absolute",
//           inset: 0,
//           backgroundColor: "rgba(0,0,0,0.3)",
//           pointerEvents: "auto", // بس هي اللي بتستقبل الكليك بره الدواير
//           cursor: "pointer",
//         }}
//       />

//       {/* الدواير نفسها */}
//       {distances.map((radius, idx) => (
//         <div
//           key={idx}
//           ref={idx === distances.length - 1 ? bigCircleRef : null}
//           style={{
//             position: "absolute",
//             left: centerX - radius * zoom,
//             top: centerY - radius * zoom,
//             width: radius * 2 * zoom,
//             height: radius * 2 * zoom,
//             border: "2px solid white",
//             borderRadius: "50%",
//             backgroundColor: "rgba(255,255,255,0.1)",
//             pointerEvents: "none", // الدواير نفسها مش بتمنع الكليك تحتها
//             boxShadow: "0 0 10px rgba(255,255,255,0.3)",
//           }}
//         />
//       ))}
//     </div>
//   );
// }

// export default RadiusCircles;


import React from "react";
import { useProjectMap } from "../../api/main_Map/useProjectMap";
import { BASE_URL_IMG } from "../../api/apiConfig";

function RadiusCircles({ isVisible, onHideRadius, mapWidth, mapHeight }) {
  const { projectData, loading } = useProjectMap("sadan") || {};

  if (!isVisible || loading || !projectData?.circle_svg) return null;

  const circle_svgImage = `${BASE_URL_IMG}/${projectData.circle_svg}`;

  return (
    <div
      onClick={onHideRadius}  // كليك خارج الـ img يخفيها
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        width: mapWidth,
        height: mapHeight,
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",  // يفعل التفاعل فقط لما تكون visible
        zIndex: 8,
      }}
    >
      <img
        src={circle_svgImage}
        alt="Radius Circles"
        draggable={false}
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          objectFit: "contain",  // ← التغيير الرئيسي: contain بدل cover عشان تحافظ على النسبة والحجم الأصلي
          pointerEvents: "none",  // الـ img نفسها مش تفاعلية، الكليك يكون على الـ div
        }}
      />
    </div>
  );
}

export default RadiusCircles;


// import React from "react";
// import { useProjectMap } from "../../api/main_Map/useProjectMap";
// import { BASE_URL_IMG } from "../../api/apiConfig";

// function RadiusCircles({ isVisible, pos, onHideRadius, mapWidth, mapHeight }) {
//   // 1️⃣ استدعاء الـ hook دايمًا أول حاجة
//   const { projectData, loading } = useProjectMap("sadan") || {};

//   // 2️⃣ الآن ممكن نعمل return null حسب الشروط
//   if (!isVisible || !pos || loading || !projectData?.circle_svg) return null;

//   const circle_svgImage = `${BASE_URL_IMG}/${projectData.circle_svg}`;

//   return (
//     <div
//       onClick={onHideRadius}
//       style={{
//         position: "absolute",
//         inset: 0,
//         width: mapWidth,
//         height: mapHeight,
//         opacity: isVisible ? 1 : 0,
//         pointerEvents: "none",
//         zIndex: 8,
//       }}
//     >
//       <img
//         src={circle_svgImage}
//         alt="Project Logo"
//         draggable={false}
//         style={{
//           pointerEvents: "auto",
//           display: "block",
//           width: "100%",
//           height: "100%",
//           // objectFit: "cover",
//         }}
//       />
//     </div>
//   );
// }

// export default RadiusCircles;

